import { useState } from "react"
import { AdminEmployee } from "../../Objects/AdminEmployee/AdminEmployee"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export const useCreateAdminEmployee = () => {
  const [username, setUsername] = useState("")

  const [password, setPassword] = useState("")

  const [name, setName] = useState("")

  const [email, setEmail] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [employee, setEmployeeState] = useState<AdminEmployee | null>(null)

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (employee: AdminEmployee | null | undefined) => {
    if (employee) {
      setEmployeeState(employee)
      setUsername(employee.username)
      setName(employee.name)
      setEmail(employee.email)
      setStatus(employee.status)
    }
  }

  const handleSubmitForm = () =>
    new AdminEmployee({
      adminEmployeeId: employee?.adminEmployeeId,
      username,
      password,
      name,
      email,
      status,
    })

  return {
    username,
    password,
    name,
    email,
    status,
    handleUsernameChange,
    handlePasswordChange,
    handleNameChange,
    handleEmailChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
